export default "__VITE_ASSET__CJHuk4ih__"